module.exports = __webpack_public_path__ + "static/media/preview_proof_of_address.2e335c6d.svg";